import { Button, Space, Table, Popconfirm } from 'antd';
import { EditFilled, DeleteFilled, UserAddOutlined } from '@ant-design/icons';
import './Management.css';
import { useGetPermissions } from "../../../../hooks/useGetAdmin";
import { useQuery, gql } from '@apollo/client';

const GET_PERMISSIONS = gql`
  query GetPermissions {
    permissions {
      identifier
      name
      principals
    }
  }
`;

function App() {
  // const { data, isError, isFetching } = useGetPermissions();
  const { data, error, loading: isFetching } = useQuery(GET_PERMISSIONS);

  const handleDelete = (key) => {
    console.log(key);
  }

  const columns = [
    {
      title: 'Steam',
      dataIndex: 'identifier',
    },
    {
      title: 'Name',
      dataIndex: 'name',
    },
    {
      title: 'Permissions',
      dataIndex: 'principals',
    },
    {
      title: 'Actions',
      dataIndex: 'actions',
      align: 'center',
      width: '5%',
      render: (_, record) =>
        data?.permissions.length >= 1 ? (
          <Space>
            <Popconfirm title="Edit coming soon" onConfirm={() => handleDelete(record.key)}>
              <EditFilled />
            </Popconfirm>
            <Popconfirm title="Do you want to delete this record?" onConfirm={() => handleDelete(record.key)}>
              <DeleteFilled />
            </Popconfirm>
          </Space>
        ) : null,
    }
  ];

  const onTableChange = (pagination, filters, sorter, extra) => {
    console.log(pagination, filters, sorter, extra)
  }

  if (!isFetching && error) {
    return <p>Error: {error.message}</p>;
  }

  return (
    <>
      <div>
        <h1>Management</h1>
        <p>Add / remove ranks from staff members</p>
      </div>
      <Space direction="vertical" style={{ width: '100%' }}>
        <Space style={{ width: '100%', display: 'flex', justifyContent: 'end' }}>
          <Button icon={<UserAddOutlined />} type="default">Add New</Button>
        </Space>
        <Table
          width="100%"
          columns={columns}
          dataSource={data?.permissions}
          loading={isFetching}
          onChange={onTableChange}
        />
      </Space>
    </>
  );
}

export default App;
